import { useState } from 'react';

import { Button, Icon } from '@liscio/ui';

import { RfiUnarchiveDialog } from '../../dialogs/RfiUnarchiveDialog';

export interface RfiUnarchiveButtonProps {
  requestUuid: string;
  onSuccessfulUnarchive?: () => void;
}

export const RfiUnarchiveButton: React.FC<RfiUnarchiveButtonProps> = ({
  requestUuid,
  onSuccessfulUnarchive,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="outlined" color="info" startIcon={<Icon icon="unarchive" />}>
        Unarchive
      </Button>
      <RfiUnarchiveDialog
        open={open}
        onClose={() => setOpen(false)}
        requestUuid={requestUuid}
        onSuccessfulUnarchive={onSuccessfulUnarchive}
      />
    </>
  );
};

export default RfiUnarchiveButton;
